import { useAssetUrl } from '../../common/Helpers';
import Styles from './Background.module.css';
import { ReactNode, RefObject, useMemo } from 'react';
import type { IAssetDTO } from '../../models/IAssetDTO';

/** Props for the Background component. */
interface IBackgroundDTO {
  children?: ReactNode;
  assetDTO?: IAssetDTO;
  classNameContainer?: string;
  ref?: RefObject<HTMLDivElement | null>;
}

/**
 * Renders a Background control that loads an image asset from the specified manifest and bundle.
 *
 * @param props - Component props.
 * @returns The rendered Background element.
 */
export function Background(props: IBackgroundDTO) {
  const { children, assetDTO, classNameContainer, ref } = props;
  const imageURL = useAssetUrl(assetDTO ?? null);

  // Compute class names an inline styles
  const containerClassName = useMemo(() => (classNameContainer ? `${Styles.container} ${classNameContainer}` : Styles.container), [classNameContainer]);
  const style = useMemo(() => (imageURL ? { backgroundImage: `url(${imageURL})` } : undefined), [imageURL]);

  // Render Background element
  return (
    <>
      {imageURL && <img src={imageURL} crossOrigin="anonymous" style={{ display: 'none' }} />}
      <div ref={ref} className={containerClassName} style={style}>
        {children}
      </div>
    </>
  );
}
